export const NAVBAR_WIDTH = 248;
export const NAVBAR_WIDTH_COLLAPSED = 94;
